var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgChrome = function SvgChrome(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chrome_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#chrome_svg__b)",
    d: "M8 4h7a8.04 8.04 0 0 0-2.959-2.928 8.147 8.147 0 0 0-8.083 0A8.04 8.04 0 0 0 1 4.001L4.5 10h.003a3.963 3.963 0 0 1-.005-4.001 4.016 4.016 0 0 1 1.48-1.465A4.07 4.07 0 0 1 8 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A73E8",
    d: "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#chrome_svg__c)",
    d: "M11.465 10 8 16a7.997 7.997 0 0 0 6.926-12H8.001L8 4.003A3.995 3.995 0 0 1 11.465 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#chrome_svg__d)",
    d: "M4.352 10 1.03 4A8.261 8.261 0 0 0 0 8c0 1.405.355 2.785 1.028 4a7.844 7.844 0 0 0 2.81 2.929A7.436 7.436 0 0 0 7.677 16L11 10l-.002-.002a3.92 3.92 0 0 1-1.403 1.467 3.715 3.715 0 0 1-1.92.537 3.715 3.715 0 0 1-1.919-.536A3.92 3.92 0 0 1 4.352 10Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__b",
    x1: 1,
    x2: 15,
    y1: 5,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__c",
    x1: 6.909,
    x2: 13.837,
    y1: 15.893,
    y2: 3.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__d",
    x1: 8.507,
    x2: 1.438,
    y1: 15.5,
    y2: 3.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chrome_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChrome);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;